/* global workforceContractsIndexUrl workforceContractDeleteUrl */

import React, { useCallback, useState } from 'react';

import WorkforceContractsIndexTable from './WorkforceContractsIndexTable';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

export default function WorkforceContractsIndex(props) {
    const [refreshKey, setRefreshKey] = useState(0);

    // Function to trigger a refresh
    const triggerRerender = useCallback(() => {
        setRefreshKey((prevKey) => prevKey + 1);
    }, []);

    return (
        <ConfirmationModalProvider>
            <div className="tw-flex tw-flex-col tw-gap-y-4">
                <WorkforceContractsIndexTable
                    forCancel={false}
                    key={`workforce-contracts-${refreshKey}`}
                    fetchUrl={workforceContractsIndexUrl}
                    workforceContractDeleteUrl={workforceContractDeleteUrl}
                    triggerRerender={triggerRerender}
                ></WorkforceContractsIndexTable>
            </div>
        </ConfirmationModalProvider>
    );
}
